<template>
  <a-modal :title="data.name" :visible="visible" width="95%" style="height: 95%" @cancel="handleOk">
    <template slot="footer">
      <a-button key="submit" type="primary" @click="handleOk">
        {{ $t('ok') }}
      </a-button>
    </template>
    <template v-if="mode === 'text'">
      <div class="txt-header">
        <div class="txt-title">
          <div class="title-label">{{ $t('page_my_document_filename') }}：</div>
          <div class="title-value">{{ data.name }}</div>
        </div>

        <div class="txt-title">
          <div class="title-label">{{ $t('page_my_document_format') }}：</div>
          <a-select :value="previewEncode" @change="changeEncode" style="width: 100%;">
            <a-select-option v-for="(type, index) in encodingTypes" :key="index" :value="type">{{
              type
            }}</a-select-option>
          </a-select>
        </div>
      </div>
      <textarea class="txt-content" v-model="content" disabled></textarea>
    </template>
    <template v-if="mode === 'image'">
      <img :src="content" style="max-width: 100%;height: auto;" />
    </template>
    <template v-if="mode === 'pdf'">
      <embed :src="content" type="application/pdf" style="width: 100%;height: calc(100% - 5px);" />
    </template>
    <template v-if="mode === 'flash'">
      <iframe
        :src="'/static/pdf/web/viewer.html?file=' + encodeURIComponent(content)"
        style="width: 100%;height: 70vh;"
      ></iframe>
    </template>
  </a-modal>
</template>

<script>
import { downloadGET } from '@/api/api'
import { readAsText, readAsDataURL } from '@/utils'
import { canPreviewList, previewMode } from '@/utils/commonDef'
import { ServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'
const sp = new ServiceProxy()
export default {
  data() {
    return {
      showFileInfo: false, // 是否展示预览
      mode: 'text',
      content: '',
      previewEncode: 'UTF-8', // txt文件内容预览编码格式
      previewLoading: false,
      encodingTypes: ['ANSI', 'UTF-16 LE', 'UTF-16 BE', 'UTF-8', 'GBK', 'Big5', ' Shift-JIS']
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    data: {
      handler() {
        if (this.visible && this.data.objectKey) {
          this.mode = 'text'
          this.previewEncode = 'UTF-8'
          this.handleDownload(this.data)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    changeEncode(value) {
      this.previewEncode = value
    },
    handleOk() {
      this.$emit('close')
    },
    handleDownload(data) {
      this.setContent('', true)
      if (data.suffix.toLowerCase() === 'pdf') {
        data.contentType = 'application/pdf'
        sp.statFileUsingGET(data.objectKey).then((res) => {
          this.mode = 'pdf'
          this.setContent(res.data.link, false)
        })
        return
      }
      downloadGET(data.objectKey, data.objectKey, data.contentType).then(
        (res) => {
          // 预览
          this.filePreview(res, data)
        },
        () => {
          this.setContent('', false)
        }
      )
    },
    // 文件预览
    async filePreview(content, file) {
      let url = undefined
      let a = /.*\.(.*)$/
      let suffix = ''
      let name = file.name
      if (name.indexOf('.') != -1) {
        suffix = a.exec(name)[1]
      } else {
        suffix = 'nc'
      }
      if (!canPreviewList.includes(suffix.toLowerCase())) {
        let result = await readAsText(content, this.previewEncode)
        this.setContent(result, false)
      } else {
        for (let key in previewMode) {
          previewMode[key].map(async (item) => {
            if (suffix.toLowerCase() === item) {
              this.mode = key
              switch (key) {
                case 'text':
                  let result = await readAsText(content, this.previewEncode)
                  this.setContent(result, false)
                  break
                case 'image':
                  url = await readAsDataURL(content)
                  this.setContent(url, false)
                  break
              }
            }
          })
        }
      }
    },
    // 设置预览的内容
    setContent(data, status) {
      this.content = data
      this.previewLoading = status
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-modal-body {
  min-height: 680px;
  height: 680px;
  overflow-y: auto;
  .txt-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .txt-title {
    width: 25%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .title-label {
    width: 95px;
  }
  .title-value {
    width: calc(100% - 95px);
  }
  .txt-content {
    width: 100%;
    height: calc(100% - 48px);
    margin-top: 8px;
  }
}
</style>
